<div
  class="first-visit-hint"
  [class.first-visit-hint--end]="alignEnd()"
  role="status"
  [style.--first-visit-hint-arrow-left]="arrowLeft()"
>
  <p class="first-visit-hint__title">{{ titleKey() | translate }}</p>
  @if (descriptionKey(); as description) {
    <p class="first-visit-hint__description">{{ description | translate }}</p>
  }
  <button
    type="button"
    class="first-visit-hint__got-it"
    (pointerdown)="onGotItPointerDown($event)"
    (click)="onGotItClick($event)"
  >
    {{ 'gotIt' | translate }}
  </button>
</div>
